import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    modal: {
      '& .MuiDialog-paper': {
        borderRadius: '12px',
        border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
        '@media (max-width: 768px)': {
          margin: '20px !important',
        },
      },
      '& .MuiModal-backdrop': {
        backgroundColor: STYLE.COLOR.MODAL_BACKDROP,
      },
    },
    modalTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '20px !important',
      color: STYLE.COLOR.TEXT1,
      lineHeight: '28px !important',
      '@media (max-width: 600px)': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        padding: '16px 16px !important',
      },
    },
    closeIconParent: {
      height: '28px',
      width: '28px',
      padding: '0px !important',
      marginLeft: '16px',
      '@media (max-width: 600px)': {
        height: '24px',
        width: '24px',
        marginLeft: '8px',
      },
    },
    modalContent: {
      borderTop: `2px dashed ${STYLE.COLOR.TABS_BORDER}`,
      padding: '22px 24px !important',
      '@media (max-width: 600px)': {
        padding: '16px 16px !important',
      },
    },
    modalActions: {
      borderTop: `2px solid ${STYLE.COLOR.TABS_BORDER}`,
      padding: '16px 24px !important',
      '& > button + button': {
        marginLeft: '12px !important',
      },
      '@media (max-width: 600px)': {
        padding: '12px 16px !important',
        flexDirection: 'column',
        '& > button': {
          width: '100% !important',
        },
        '& > button + button': {
          marginLeft: '0 !important',
          marginTop: '8px !important',
        },
      },
    },
    button: {
      height: '44px !important',
    },
  }),
);
